import 'css-chunk:src/applications/GroupContentApp/SubmittedContent/components/Issues/Issues.module.scss';export default {
  "Issues": "_Issues_p39zu_1",
  "item": "_item_p39zu_4",
  "avatar": "_avatar_p39zu_10",
  "checkbox": "_checkbox_p39zu_10",
  "info": "_info_p39zu_13"
};